export const filters = [
  { id: 'all', label: 'All', count: 5 },
  { id: 'disputes', label: 'Disputes', count: 2 },
  { id: 'regulatory', label: 'Regulatory', count: 1 },
  { id: 'labour', label: 'Labour', count: 1 },
  { id: 'opinions', label: 'Opinions', count: 1 }
];

export const cards = [
  { label: 'Open matters', value: '4', note: 'Live', accent: 'dark' },
  { label: 'In litigation / regulatory', value: '2', note: 'Active exposure', accent: 'amber' },
  { label: 'High risk', value: '2', note: 'Material matters', accent: 'red' },
  { label: 'Key dates this month', value: '3', note: 'Deadlines approaching', accent: 'amber' }
];

export const rows = [
  { ref: 'LM-01', matter: 'Supplier contract-termination dispute', case_type: 'Contractual dispute', parties: 'BlueData Services', attorney: 'A. de Wet (Legal)', risk: 'High', status: { label: 'Litigation', class: 'bg-danger-subtle text-danger-emphasis' }, filter_id: 'disputes' },
  { ref: 'LM-02', matter: 'Unfair dismissal referral - CCMA', case_type: 'Labour dispute', parties: 'Former employee', attorney: 'Employment counsel', risk: 'Medium', status: { label: 'At CCMA', class: 'bg-warning-subtle text-warning-emphasis' }, filter_id: 'labour' },
  { ref: 'LM-03', matter: 'Information Regulator enquiry - POPIA', case_type: 'Regulatory notice', parties: 'Information Regulator', attorney: 'A. de Wet (Legal)', risk: 'High', status: { label: 'Response due', class: 'bg-danger-subtle text-danger-emphasis' }, filter_id: 'regulatory' },
  { ref: 'LM-04', matter: 'Third-party claim - vehicle accident', case_type: 'Third-party claim', parties: 'Other driver', attorney: 'Insurer panel attorney', risk: 'Low', status: { label: 'Monitoring', class: 'bg-warning-subtle text-warning-emphasis' }, filter_id: 'disputes' },
  { ref: 'LM-05', matter: 'Legal opinion - sole-source legality', case_type: 'Legal opinion', parties: 'Internal (Procurement)', attorney: 'A. de Wet (Legal)', risk: 'Low', status: { label: 'Opinion issued', class: 'bg-success-subtle text-success-emphasis' }, filter_id: 'opinions' }
];

export const legal_matter_drawer_catalog = {
  'LM-01': {
    kicker: 'Legal matter',
    badge: { label: 'Litigation', class: 'bg-danger-subtle text-danger-emphasis' },
    subtitle: 'Supplier disputes termination',
    details: [
      { label: 'Matter', value: 'Supplier disputes contract termination' },
      { label: 'Case type', value: 'Contractual dispute' },
      { label: 'Parties involved', value: 'Company v BlueData Services' },
      { label: 'Responsible attorney', value: 'A. de Wet - external counsel briefed' },
      { label: 'Linked contract', value: 'BlueData K-105' },
      { label: 'Key dates', value: 'Letter of demand 02 May - plea due 30 Jun 2026' },
      { label: 'Legal opinion', value: 'Counsel: termination defensible' },
      { label: 'Settlement', value: 'Not pursued - defending' },
      { label: 'Court documents', value: 'Summons, plea, contract bundle' },
      { label: 'Risk rating', value: 'High' },
      { label: 'Evidence', value: 'Procurement & performance evidence pack' },
      { label: 'Status', value: 'Litigation' }
    ],
    evidence_checks_title: 'Evidence & checks',
    evidence_checks_badge: '1 need action',
    evidence_checks: [
      { title: 'Termination grounds', subtitle: 'Material breach documented', state: 'good', state_label: 'Sound' },
      { title: 'Plea deadline', subtitle: 'Due 30 Jun 2026', state: 'due', state_label: 'Due' },
      { title: 'Legal opinion', subtitle: 'Defensible - counsel briefed', state: 'good', state_label: 'On file' }
    ],
    connected_records: [
      { type: 'Supplier', title: 'BlueData Services' },
      { type: 'Contract', title: 'BlueData K-105' },
      { type: 'Procurement', title: 'Procurement evidence' },
      { type: 'Incident', title: 'Performance incidents' },
      { type: 'Risk', title: 'Litigation risk' },
      { type: 'Evidence', title: 'Legal evidence pack' },
      { type: 'Calendar', title: 'Plea deadline' },
      { type: 'Reports', title: 'Litigation report' }
    ],
    recommendation: 'A supplier disputes its contract termination. The matter links the supplier profile, contract record, procurement evidence, incident history, risk register and legal evidence pack - meet the plea deadline and keep the evidence bundle current.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open matter file' }
  },
  'LM-02': {
    kicker: 'Legal matter',
    badge: { label: 'At CCMA', class: 'bg-warning-subtle text-warning-emphasis' },
    subtitle: 'CCMA conciliation / arbitration',
    details: [
      { label: 'Matter', value: 'Unfair dismissal referral' },
      { label: 'Case type', value: 'Labour dispute (CCMA)' },
      { label: 'Parties involved', value: 'Former employee v Company' },
      { label: 'Responsible attorney', value: 'External employment counsel' },
      { label: 'Linked employee', value: 'Ex-employee (disciplinary record)' },
      { label: 'Key dates', value: 'Conciliation 18 Jun 2026' },
      { label: 'Risk rating', value: 'Medium' },
      { label: 'Evidence', value: 'Disciplinary record, hearing minutes' },
      { label: 'Status', value: 'At CCMA' }
    ],
    evidence_checks_title: null,
    evidence_checks_badge: null,
    evidence_checks: [],
    connected_records: [
      { type: 'Employee', title: 'Disciplinary record' },
      { type: 'Risk', title: 'Labour risk' },
      { type: 'Evidence', title: 'Hearing minutes' },
      { type: 'Calendar', title: 'Conciliation date' }
    ],
    recommendation: 'Ensure the disciplinary record and hearing minutes are complete before conciliation. A defensible process record is the difference between settlement and an adverse award.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open matter file' }
  },
  'LM-03': {
    kicker: 'Legal matter',
    badge: { label: 'Response due', class: 'bg-danger-subtle text-danger-emphasis' },
    subtitle: 'Regulatory notice - unsigned DPA',
    details: [
      { label: 'Matter', value: 'Regulator enquiry into processing without a DPA' },
      { label: 'Case type', value: 'Regulatory notice' },
      { label: 'Parties involved', value: 'Information Regulator' },
      { label: 'Responsible attorney', value: 'A. de Wet + Information Officer' },
      { label: 'Key dates', value: 'Response due 25 Jun 2026' },
      { label: 'Risk rating', value: 'High' },
      { label: 'Evidence', value: 'Processing register, remediation plan' },
      { label: 'Status', value: 'Response due' }
    ],
    evidence_checks_title: 'Evidence & checks',
    evidence_checks_badge: '2 need action',
    evidence_checks: [
      { title: 'BlueData DPA', subtitle: 'Still unsigned (OB-02)', state: 'open', state_label: 'Open' },
      { title: 'Regulator response', subtitle: 'Due 25 Jun 2026', state: 'due', state_label: 'Due' }
    ],
    connected_records: [
      { type: 'Data privacy', title: 'POPIA register' },
      { type: 'Risk', title: 'Regulatory risk' },
      { type: 'Evidence', title: 'Remediation evidence' },
      { type: 'Calendar', title: 'Response deadline' },
      { type: 'Reports', title: 'Board notification' }
    ],
    recommendation: 'A regulatory deadline is running. Sign the outstanding DPA, attach the remediation plan and file the response before 25 Jun - non-response escalates the exposure materially.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Draft response' }
  },
  'LM-04': {
    kicker: 'Legal matter',
    badge: { label: 'Monitoring', class: 'bg-warning-subtle text-warning-emphasis' },
    subtitle: 'Handled via insurer',
    details: [
      { label: 'Matter', value: 'Third-party claim from a vehicle accident' },
      { label: 'Case type', value: 'Third-party claim' },
      { label: 'Parties involved', value: 'Other driver v Company' },
      { label: 'Responsible attorney', value: 'Insurer panel attorney' },
      { label: 'Linked claim', value: 'Fleet claim CL-08' },
      { label: 'Risk rating', value: 'Low' },
      { label: 'Evidence', value: 'Accident report, police case' },
      { label: 'Status', value: 'Monitoring' }
    ],
    evidence_checks_title: null,
    evidence_checks_badge: null,
    evidence_checks: [],
    connected_records: [
      { type: 'Insurance', title: 'Fleet claim CL-08' },
      { type: 'Asset', title: 'Toyota Hilux' },
      { type: 'Incident', title: 'Accident report' },
      { type: 'Evidence', title: 'Claim pack' }
    ],
    recommendation: "Defence is run by the insurer's panel attorney. Keep the accident report and police case synced with the fleet claim (CL-08) - no direct action unless the insurer requests it.",
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'Open matter file' }
  },
  'LM-05': {
    kicker: 'Legal matter',
    badge: { label: 'Opinion issued', class: 'bg-success-subtle text-success-emphasis' },
    subtitle: 'Procurement legality opinion',
    details: [
      { label: 'Matter', value: 'Legality of a sole-source software renewal' },
      { label: 'Case type', value: 'Legal opinion' },
      { label: 'Parties involved', value: 'Internal - Procurement' },
      { label: 'Responsible attorney', value: 'A. de Wet' },
      { label: 'Legal opinion', value: 'Permissible with documented motivation' },
      { label: 'Risk rating', value: 'Low' },
      { label: 'Status', value: 'Opinion issued' }
    ],
    evidence_checks_title: null,
    evidence_checks_badge: null,
    evidence_checks: [],
    connected_records: [
      { type: 'Procurement', title: 'Sole-source pack' },
      { type: 'Exception', title: 'Sole-source EX-02' },
      { type: 'Contract', title: 'Renewal contract' },
      { type: 'Evidence', title: 'Opinion document' }
    ],
    recommendation: 'Opinion issued: the sole-source renewal is permissible with a documented motivation. File it against the exception (EX-02) so the audit trail is complete.',
    footer: { left_label: 'Watch', secondary_label: 'Evidence', primary_label: 'View opinion' }
  }
};

export const ai_briefing = {
  title: "This week's compliance posture",
  body: [
    'Procurement, finance and supplier compliance remain the highest-risk areas this week.',
    'Five issues are blocking actions right now:',
    '1. ABC Tech supplier tax certificate has expired - payment gate is holding INV-2219.',
    '2. BlueData is processing personal data without a signed DPA (control C-216 failed).',
    '3. Admin access review is overdue 14 days (control C-322 failed).',
    '4. Platform support agreement is over the R 500 000 CFO threshold.',
    '5. K. Sithole holds a critical conflict on XYZ Consulting - recused and approval-blocked.',
    'Cross-system status: AGSA audit readiness 70%, evidence completeness 73%, 16 board/committee decisions outstanding.',
    'Recommended: hold the two payments, trigger OnboardOS revalidation for ABC Tech, execute the BlueData DPA, and table the four material items at the next Audit & Risk Committee.'
  ],
  footer: '5 sources - 4 controls - 3 evidence items - 1 policy'
};

export const ai_questions = [
  'What evidence is missing for ABC Tech?',
  'Can INV-2219 be paid?',
  'Are we ready for the AGSA audit?',
  'Which controls failed this month?',
  'What decisions need the board?',
  'Where are we repeating findings?',
  "What's overdue this week?",
  'Can we prove it? Evidence gaps'
];
